module.exports = __webpack_public_path__ + "img/one_14.e329b1d7.jpg";